import React from "react";
import { DropdownPlaceholder } from "./DropdownPlaceholder";
import { DropdownSelected } from "./DropdownSelected";
import { DropdownOptionModel } from "../tools/Dropdown.model";

export const DropdownDefaultValue = ({
  options,
  value,
  placeholderDisplayType,
  placeholder,
}: {
  options: DropdownOptionModel[];
  value: string | string[];
  placeholderDisplayType?: 'dynamic' | 'always';
  placeholder?: string;
}) => {
  const option = options.find(opt => opt.value === value);
  const optionLabel = option?.label;
  const optionLabelPrefix = option?.labelPrefix;
  if (placeholderDisplayType === "dynamic") {
    return !value ? (
      <DropdownPlaceholder placeholder={placeholder} value={value} />
    ) : (
      <DropdownSelected
        value={value}
        label={optionLabel}
        labelPrefix={optionLabelPrefix}
      />
    );
  } else if (placeholderDisplayType === "always") {
    return <DropdownPlaceholder placeholder={placeholder} value={value} />;
  } else {
    return (
      <DropdownSelected
        value={value}
        label={optionLabel}
        labelPrefix={optionLabelPrefix}
      />
    );
  }
};
